// extracted by mini-css-extract-plugin
export var actionButton = "_4y-1";
export var actionButtons = "_4y-2";
export var actions = "_4y-0";
export var aiUnread = "_4y-10";
export var alignCenter = "_4y-h";
export var backWrapper = "_4y-3";
export var cellContainer = "_4y-4";
export var checkboxContainer = "_4y-5";
export var contentContainer = "_4y-6";
export var contentHeader = "_4y-8";
export var conversationsTableWrapper = "_4y-s";
export var draftReplyBadgeContainer = "_4y-m";
export var dropdownItem = "_4y-b";
export var dropdownItemsContainer = "_4y-a";
export var dropdownTitle = "_4y-c";
export var errorIcon = "_4y-7";
export var filter = "_4y-d";
export var gray = "_4y-i";
export var headerActionButtons = "_4y-e";
export var headerCheckboxContainer = "_4y-f";
export var icon = "_4y-j";
export var menuContainer = "_4y-k";
export var noMoreTicketsIcon = "_4y-12";
export var noMoreTicketsSubText = "_4y-13";
export var oneLine = "_4y-l";
export var optionsButton = "_4y-n";
export var plus = "_4y-o";
export var portalButtonsWrapper = "_4y-g";
export var red = "_4y-p";
export var scrolledTop = "_4y-9";
export var search = "_4y-q";
export var selectedConversationsCount = "_4y-r";
export var spinner = "_4y-t";
export var strong = "_4y-u";
export var summaryCell = "_4y-v";
export var tableContainer = "_4y-11";
export var tagContainer = "_4y-w";
export var threeDots = "_4y-x";
export var twoLines = "_4y-y";
export var unread = "_4y-z";